import { PixelRatio, StyleSheet, Text, View, Dimensions } from "react-native";
import "../../utils/polyfills/textEncoding";
import QRCode from "react-native-qrcode-svg";

const { width, height } = Dimensions.get("window");

// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const QRTableScan = ({
  username = "mike",
  tableValue = 2500,
  tableCaption = "The Chase Table",
}) => {
  const qrData = JSON.stringify({
    username,
    tableValue,
    tableCaption,
  });

  // Make QR code size responsive to screen width
  const qrSize = width * 0.8; // 80% of screen width

  return (
    <View style={styles.container}>
      <QRCode value={qrData} size={qrSize} />
    </View>
  );
};

export default QRTableScan;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
  },
});
